import { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import balloon from '../../../images/balloon.png'
import coin1 from '../../../images/coin1.png'
import coin2 from '../../../images/coin2.png'
import coin3 from '../../../images/coin3.png'
import coin4 from '../../../images/coin4.png'
import coin5 from '../../../images/coin5.png'
import coin6 from '../../../images/coin6.png'
import coin7 from '../../../images/coin7.png'
import logoImage from '../../../images/logo-big.png'

import flagRu from '../../../images/flag-ru.png'
import flagKz from '../../../images/flag-kazakhstan.png'
import girl from '../../../images/girl.png'
import girlsBalloon from '../../../images/girls_balloon.png'

import styles from './styles.module.css'
import Modal from './Modal'
import Wheel from './Wheel'
import { AdCommonEvents, callPixelEvent, ContextApp } from '@monorepo/service'
import { Locale, useLogin } from '@monorepo/api'
import { classNames } from '@monorepo/utils'

const App = () => {
  const { isCdaCheck, isCdaBalancerInfoLoading, cdaBalancerInfo } = useContext(ContextApp)
  const { t, i18n } = useTranslation()
  const [spinsCount, setSpinsCount] = useState(4)
  // 0 - закрыто, 1 - выиграл, 2/3 - вигрый, 4 - регистрация
  const [isOpenModal, setIsOpenModal] = useState(0)
  const [isAnimate, setIsAnimate] = useState(false)
  const [toggleDropdown, setToggleDropdown] = useState(false)

  const { redirectToLoginPage } = useLogin({
    geo: 'KZ',
    isBalancerInfoLoading: isCdaBalancerInfoLoading,
    balancerInfo: cdaBalancerInfo,
  })

  useEffect(() => {
    if (i18n.language) Locale.set(i18n.language)
  }, [i18n.language])

  useEffect(() => {
    if (isCdaCheck) {
      callPixelEvent({ event: AdCommonEvents.Visit })
      callPixelEvent({ event: AdCommonEvents.LandingPageView })
    }
  }, [isCdaCheck])

  useEffect(() => {
    if (isOpenModal === 4 && isCdaCheck) callPixelEvent({ event: AdCommonEvents.RegNotFinished })
  }, [isOpenModal, isCdaCheck])

  const handleSpin = () => {
    setIsAnimate(true)
    setTimeout(() => {
      setSpinsCount((prev) => prev - 1)
      setIsAnimate(false)
      setIsOpenModal(spinsCount - 1)
    }, 6000)
  }

  const handleCloseModal = () => {
    setIsOpenModal(0)
    handleSpin()
  }

  const handleOpenReg = useCallback(() => setIsOpenModal(4), [])

  return (
    <div className={styles.background}>
      <div className={styles.backgroundImage} />

      <div className={styles.main}>
        <div className={styles.mainColumn}>
          {isOpenModal !== 4 && (
            <div className={styles.header}>
              <img className={styles.logo} src={logoImage} alt="Logo" />
              <div className={styles.navContainer}>
                <a
                  className={classNames(
                    styles.enterButton,
                    isCdaBalancerInfoLoading && styles.loading,
                  )}
                  onClick={redirectToLoginPage}
                >
                  {t('global.enter')}
                </a>
                <div className={styles.languageSelector}>
                  <div
                    className={styles.selected}
                    onClick={() => setToggleDropdown(!toggleDropdown)}
                  >
                    <img src={i18n.language === 'ru' ? flagRu : flagKz} alt="RU" />
                    <span>{i18n.language === 'ru' ? 'RU' : 'KZ'}</span>
                    <span className={styles.arrow}>▾</span>
                  </div>
                  {toggleDropdown && (
                    <div className={styles.dropdown}>
                      <div className={styles.option} onClick={() => i18n.changeLanguage('ru')}>
                        <img src={flagRu} alt="RU" />
                        <span>RU</span>
                      </div>
                      <div className={styles.option} onClick={() => i18n.changeLanguage('kz')}>
                        <img src={flagKz} alt="KZ" />
                        <span>KZ</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className={styles.ribbons}>
            <img className={styles.balloon} src={balloon} alt="Balloon" />
            <div className={styles.title}>{t('global.register')}</div>
            <div className={styles.bonus}>{t('global.getBonus')}</div>
          </div>
          <div className={styles.gameContainer}>
            <Wheel
              isAnimate={isAnimate}
              isOpenModal={isOpenModal}
              spinsCount={spinsCount}
              disabled={isAnimate || spinsCount < 2}
              onSpin={handleSpin}
            />
          </div>
        </div>
      </div>

      <div className={styles.decorItem1}></div>
      <div className={styles.girlsContainer}>
        <img className={styles.girl} src={girl} alt="Girl" />
        <img className={styles.girlsBalloon} src={girlsBalloon} alt="Girls balloon" />
      </div>

      <img className={styles.coin1} src={coin1} alt="Coin 1" />
      <img className={styles.coin2} src={coin2} alt="Coin 2" />
      <img className={styles.coin3} src={coin3} alt="Coin 3" />
      <img className={styles.coin4} src={coin4} alt="Coin 4" />
      <img className={styles.coin5} src={coin5} alt="Coin 5" />
      <img className={styles.coin6} src={coin6} alt="Coin 6" />
      <img className={styles.coin7} src={coin7} alt="Coin 7" />
      <Modal isOpenModal={isOpenModal} closeModal={handleCloseModal} openReg={handleOpenReg} />
    </div>
  )
}

export default App
